import * as React from "react";
import { Button, StickyCallToAction } from "@grandvisionhq/common";
const classPrefix = "mini-cart-v2";
const ActionButtons = ({
  buttonsRef,
  labels,
  links,
  shouldShowStickyButtons
}) => {
  const Buttons = /* @__PURE__ */ React.createElement(React.Fragment, null, links.cart ? /* @__PURE__ */ React.createElement(
    Button,
    {
      "aria-label": labels.toCart,
      caption: labels.toCart,
      className: `${classPrefix}__action-button`,
      href: links.cart,
      size: "small",
      "data-t": `${classPrefix}-action-button`
    }
  ) : null, links.checkout ? /* @__PURE__ */ React.createElement(
    Button,
    {
      "aria-label": labels.toCheckout,
      caption: labels.toCheckout,
      className: `${classPrefix}__action-button`,
      href: links.checkout,
      size: "small",
      variant: "outline",
      "data-t": `${classPrefix}-action-button`
    }
  ) : null);
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement("div", { className: `${classPrefix}__action-buttons`, ref: buttonsRef }, Buttons), shouldShowStickyButtons ? /* @__PURE__ */ React.createElement(StickyCallToAction, { button: Buttons }) : null);
};
export {
  ActionButtons
};
//# sourceMappingURL=ActionButtons.js.map
